import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import RouteBadge from './RouteBadge';

function formatTime(duration) {
  return duration.substring(0, duration.lastIndexOf(':'));
}

class TourHotelRouteItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: null
    };
    this.setCurrentRoute = this.setCurrentRoute.bind(this);
  }
  componentWillMount(){
    if (this.props.route.place.city == null){
      this.setState({
        location: `${this.props.route.place.state}, ${this.props.route.place.country}`,
      })
    }
    if (this.props.route.place.state == null){
      this.setState({
        location: `${this.props.route.place.city}, ${this.props.route.place.country}`,
      })
    }
    if (this.props.route.place.city == null && this.props.route.place.state == null){
      this.setState({
        location: `${this.props.route.place.name}, ${this.props.route.place.country}`,
      })      
    }
    if (this.props.route.place.state == null && this.props.route.place.country==null ){
      this.setState({
        location: `${this.props.route.place.city}`,
      })      
    }
    if (this.props.route.place.city == null && this.props.route.place.state == null && this.props.route.place.country == null){
      if(this.props.route.place.name==null){
        this.setState({
          location: '',
        })
      }else{
        this.setState({
          location: `${this.props.route.place.name}`,
        })
      }
    }
    if (this.props.route.place.city != null && this.props.route.place.state != null && this.props.route.place.country != null){
      if (this.props.route.place.city === this.props.route.place.state){
        this.setState({
        location: `${this.props.route.place.city}, ${this.props.route.place.country}`,
      })
      } else{
        if(this.props.route.place.state === this.props.route.place.country){
          this.setState({
            location: `${this.props.route.place.city}, ${this.props.route.place.country}`,
          })
        }else{
          this.setState({
            location: `${this.props.route.place.city}, ${this.props.route.place.state}, ${this.props.route.place.country}`,
          })
        }
       }
    }
  }
  setCurrentRoute(e) {
    e.preventDefault();
    this.props.selectRoute(this.props.route.id);
  }
  render() {
    const classes = classnames('item', { active: this.props.selected });
    const { route } = this.props;
    return (
      <div className={classes} onClick={this.setCurrentRoute} role="presentation">
        <div className="event-date">
          <div onClick={this.setCurrentRoute}>
            <strong className="event-location">
              {this.state.location}
            </strong>
            {this.props.innergroup &&(
              <div className='showspace'>
                <br></br>
                <br></br>
              </div>
            )}
            {!this.props.innergroup &&(
              <div>
              <RouteBadge related_group_events={route.related_group_events} />
              <br />

            <i className="fa fa-road fa-lg" />
            <i className="fa fa-clock-o fa-lg" title="Drive time to next venue." />
            <strong className="event-location"> {formatTime(route.duration_to_next)}</strong>
            </div>
            )}
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

TourHotelRouteItem.propTypes = {
  route: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  selectRoute: PropTypes.func.isRequired,
};

export default TourHotelRouteItem;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelRouteItem.js